var languages = {
    headerSt: {
        en: 'Lotteries',
        ro: 'Loterii',
        ru: 'Лотерея',
        uk: 'Лотерея',
        pt: 'Lotarias',
        gr: 'Λοταρίες',
        de: 'Lotterien',
        no: 'Lotterier',
        da: 'Lotterier',
        es: 'Loterías',
        fr: 'Loteries',
        ja: '宝くじ',
        fi: 'Lotot', //end
    },
    headerDr: {
        en: 'Tickets',
        ro: 'Bilet de pariuri',
        ru: 'Купоны',
        uk: 'Білети',
        pt: 'Bilhetes',
        gr: 'Δελτίο στοιχημάτων',
        de: 'Wettschein',
        no: 'Veddemål billett',
        da: 'Væddemål billett',
        es: 'Boletos',
        fr: 'Billet de paris',
        ja: 'チケット',
        fi: 'Kupongit', //end
    },
    bilete0: {
        en: 'No tickets created',
        ro: '0 bilete create',
        ru: 'Билеты не были созданы',
        uk: 'Білети не були створені',
        pt: 'Não foram criados bilhetes',
        gr: '0 δελτία δημιουργήθηκαν',
        de: 'Es wurden kein tickets erstellt',
        no: '0 billetter opprettet',
        da: '0 billetter oprettet',
        es: 'No hay boletos creados',
        fr: '0 billets crees',
        ja: 'チケットは作成されていません',
        fi: 'Ei täytettyjä kuponkeja', //end
    },
    biletGol: {
        en: 'The ticket is empty.',
        ro: 'Biletul este gol.',
        ru: 'Билет пустой',
        uk: 'Білет порожній',
        pt: 'O bilhete está vazio.',
        gr: 'Το δελτίο είναι άδειο',
        de: 'Das Ticket ist leer.',
        no: 'Billetten er tom.',
        da: 'Billetten er tom.',
        es: 'El boleto está vacío.',
        fr: 'Le billet est vide',
        ja: 'チケットは空です。',
        fi: 'Kupoonki on tyhjä.', //end
    },
    sterge: {
        en: 'Delete',
        ro: 'Șterge',
        ru: 'Удалить',
        uk: 'Видалити',
        pt: 'Apagar',
        gr: 'Σβήσε',
        de: 'Löschen',
        no: 'Klar',
        da: 'Klar',
        es: 'Borrar',
        fr: 'Efface',
        ja: '削除する',
        fi: 'Poista', //end
    },
    system: {
        en: 'System',
        ro: 'Sistem',
        ru: 'Система',
        uk: 'Система',
        pt: 'Sistema',
        gr: 'Σύστημα',
        de: 'System',
        no: 'System',
        da: 'System',
        es: 'Sistema',
        fr: 'Système',
        ja: 'システム',
        fi: 'Järjestelmä', //end
    },
    systems: {
        en: 'Systems',
        ro: 'Sisteme',
        ru: 'розыгрыши',
        uk: '',
        pt: 'Sistemas',
        gr: 'Συστήματα',
        de: 'Systeme',
        no: 'Systemer',
        da: 'Systemer',
        es: 'Sistemas',
        fr: 'Systèmes',
        ja: 'ベット',
        fi: 'Järjestelmät', //end
    },
    pariu: {
        en: 'bet',
        ro: 'pariu',
        ru: 'ставка',
        uk: 'ставка',
        pt: 'aposta',
        gr: 'στοίχημα',
        de: 'wette',
        no: 'sats',
        da: 'væddemål',
        es: 'apuesta',
        fr: 'pari',
        ja: 'ベット',
        fi: 'veto', //end
    },
    pariuri: {
        en: 'bets',
        ro: 'pariuri',
        ru: 'ставки',
        uk: 'ставки',
        pt: 'apostas',
        gr: 'στοιχήματα',
        de: 'wetten',
        no: 'satser',
        da: 'væddemål',
        es: 'apuestas',
        fr: 'paris',
        ja: 'ベット',
        fi: 'vedot', //end
    },
    castig: {
        en: 'Win',
        ro: 'Câștig',
        ru: 'Выигрышный',
        uk: 'Переможний',
        pt: 'Ganho',
        gr: 'Κέρδος',
        de: 'Gewinn',
        no: 'Gevinst',
        da: 'Gevinst',
        es: 'Ganar',
        fr: 'Gain',
        ja: '勝ち',
        fi: 'Voitto', //end
    },
    pariazaBut: {
        en: 'PLACE BET',
        ro: 'Pariază',
        ru: 'СДЕЛАТЬ СТАВКУ',
        uk: 'ЗРОБИТИ СТАВКУ',
        pt: 'Apostar',
        gr: 'Στοιχημάτισε',
        de: 'WETTEINSATZ FESTLEGEN',
        no: 'Vedd på',
        da: 'Vædd på',
        es: 'Colocar la apuesta',
        fr: 'Pariez',
        ja: '賭けをする',
        fi: 'PELAA', //end
    },
    pariazaButTot: {
        en: 'Place all bets',
        ro: 'Pariază tot',
        ru: 'Сделать Все Ставки',
        uk: 'Зробити всі ставки',
        pt: 'Apostar tudo',
        gr: 'Στοιχημάτισε όλα',
        de: 'Alle Wetten abgeben',
        no: 'Vedde alt på',
        da: 'Vædd alt på',
        es: 'Colocar todas las apuestas',
        fr: 'Pariez tout',
        ja: 'すべての賭けをする',
        fi: 'Aseta kaikki vedot', //end
    },
    startDate: {
        en: 'Start date',
        ro: 'De la',
        ru: 'Дата старта',
        uk: 'Дата старту',
        pt: 'Data de início',
        gr: 'Από',
        de: 'Startdatum',
        no: 'Fra',
        da: 'Fra',
        es: 'Fecha de inicio',
        fr: 'De',
        ja: '開始日',
        fi: 'Alku pvm', //end
    },
    endDate: {
        en: 'End date',
        ro: 'Până la',
        ru: 'Дата финиша',
        uk: 'Дата фінішу',
        pt: 'Data de conclusão',
        gr: 'έως',
        de: 'Enddatum',
        no: 'Til',
        da: 'Op til',
        es: 'Fecha final',
        fr: "Jusqu'à",
        ja: '終了日',
        fi: 'Päättymis pvm', //end
    },
    istoricBilete: {
        en: 'Ticket history',
        ro: 'Istoric pariuri',
        ru: 'История билетов',
        uk: 'Історія білетів',
        pt: 'Historial do bilhete',
        gr: 'Ιστορικό στοιχημάτων',
        de: 'Ticketgeschichte',
        no: 'Veddemål historie',
        da: 'Væddemål historie',
        es: 'Historial de los boletos',
        fr: 'Historique des paris',
        ja: 'チケット履歴',
        fi: 'Entiset kupongitEniset kierrokset', //end
    },
    istoricRunde: {
        en: 'Rounds history',
        ro: 'Rezultate anterioare',
        ru: 'История туров',
        uk: 'Історія турів',
        pt: 'Historial das rondas',
        gr: 'Προηγούμενα αποτελέσματα',
        de: 'Rundengeschichte',
        no: 'Tidligere resulater',
        da: 'Tidligere resultater',
        es: 'Historial de rondas',
        fr: 'Resultés précédents',
        ja: 'ラウンドの歴史',
        fi: 'Eniset kierrokset', //end
    },
    rezultate: {
        en: 'Results',
        ro: 'Rezultate',
        ru: 'Результаты',
        uk: 'Результати',
        pt: 'Resultados',
        gr: 'Αποτελέσματα',
        de: 'Ergebnisse',
        no: 'Resultater',
        da: 'Resultater',
        es: 'Resultados',
        fr: 'Resultés',
        ja: '結果',
        fi: 'Tulokset', //end
    },
    selectatiData: {
        en: 'Select Date Range',
        ro: 'Selectați data',
        ru: 'Выберите Диапазон дат',
        uk: 'Оберіть діапазон дат',
        pt: 'Selecionar a data',
        gr: 'Διαλέξτε ημερομηνία',
        de: 'Datumsbereich auswählen',
        no: 'Velg dato',
        da: 'Vælg dato',
        es: 'Seleccione el rango de fechas',
        fr: 'Selectionnez la date',
        ja: '期間を選択',
        fi: 'Valitse aikaväli', //end
    },
    loteria: {
        en: 'Lottery',
        ro: 'Loteria',
        ru: 'Лотерея',
        uk: 'Лотерея',
        pt: 'Lotaria',
        gr: 'Λοταρία',
        de: 'Lotterie',
        no: 'Lotteri',
        da: 'Lotteri',
        es: 'Loteria',
        fr: 'Loterie',
        ja: '宝くじ',
        fi: 'Lotto', //end
    },
    status: {
        en: 'Status',
        ro: 'Status',
        ru: 'Статус',
        uk: 'Статус',
        pt: 'Estado',
        gr: 'Κατάσταση',
        de: 'Status',
        no: 'Status',
        da: 'Status',
        es: 'Estado',
        fr: 'Statut',
        ja: 'ステータス',
        fi: 'Tila', //end
    },
    pending: {
        en: 'Pending',
        ro: 'În așteptare',
        ru: 'В ожидании',
        uk: 'В очікуванні',
        pt: 'Pendente',
        gr: 'Σε αναμονή',
        de: 'Steht aus',
        no: 'Påvente',
        da: 'Afventning',
        es: 'Pendiente',
        fr: 'En attente',
        ja: '保留中',
        fi: 'Kesken', //end
    },
    pierdut: {
        en: 'Lost',
        ro: 'Pierzător',
        ru: 'Проигрыш',
        uk: 'Програш',
        pt: 'Perdedor',
        gr: 'Χαμένος',
        de: 'Verloren',
        no: 'Taper',
        da: 'Taber',
        es: 'Perdita',
        fr: 'Perdant',
        ja: 'なくした',
        fi: 'Häviö', //end
    },
    castigator: {
        en: 'Win',
        ro: 'Câștigător',
        ru: 'Выигрышный',
        uk: 'Переможний',
        pt: 'Ganhador',
        gr: 'Νικητής',
        de: 'Gewinnen',
        no: 'Vinner',
        da: 'Vinder',
        es: 'Ganador',
        fr: 'Gagnant',
        ja: '勝つ',
        fi: 'Voitto', //end
    },
    returnBet: {
        en: 'Return bet',
        ro: 'Întoarcere miza',
        ru: 'Возврат',
        uk: 'Повернення',
        pt: 'Voltar a aposta',
        gr: 'Επιστροφή πονταρίσματος',
        de: 'Wette zurückkehren',
        no: 'Innsats retur',
        da: 'Indsats retur',
        es: 'Apuesta de retorno',
        fr: 'Retour de pieu',
        ja: '賭け返す',
        fi: 'Palauta veto', //end
    },
    anulat: {
        en: 'Canceled',
        ro: 'Anulat',
        ru: 'Отменено',
        uk: 'Скасовано',
        pt: 'Cancelado',
        gr: 'Ακυρωμένο',
        de: 'Annulliert',
        no: 'Kansellert',
        da: 'Aflyst',
        es: 'Cancelado',
        fr: 'Annulé',
        ja: 'キャンセル',
        fi: 'Peruttu', //end
    },
    all: {
        en: 'All',
        ro: 'Toate',
        ru: 'Все',
        uk: 'Всі',
        pt: 'Tudo',
        gr: 'Ακυρωμένο',
        de: 'Alle',
        no: 'Kansellert',
        da: 'Aflyst',
        es: 'Todos',
        fr: 'Annulé',
        ja: 'すべて',
        fi: 'Kaikki', //end
    },
    runda: {
        en: 'Round',
        ro: 'Rundă',
        ru: 'Тур',
        uk: 'Тур',
        pt: 'Ronda',
        gr: 'Γύρος',
        de: 'Runde',
        no: 'Spillerunde',
        da: 'Spilrunde',
        es: 'Redondo',
        fr: 'Rounde',
        ja: 'ラウンド',
        fi: 'Kierros', //end
    },
    dataJucata: { /**/
        en: 'Data Played',
        ro: 'Data biletului',
        ru: 'Дата создания ставки',
        uk: 'Дата создания ставки',
        pt: 'Dados de aposta',
        gr: 'Γύρος',
        de: 'Daten abgespeilt',
        no: 'Spillerunde',
        da: 'Spilrunde',
        es: 'Datos jugados',
        fr: 'Rounde',
        ja: '再生データ',
        fi: 'Pelamis pvm', //end
    },
    nb2: {
        en: 'Numbers',
        ro: 'Numere',
        ru: 'Номера',
        uk: 'Номери',
        pt: 'Números',
        gr: 'Αριθμοί',
        de: 'Zahlen',
        no: 'Tall',
        da: 'Numre',
        es: 'Números',
        fr: 'Numéros',
        ja: '番号',
        fi: 'Numerot', //end
    },
    bilete: {
        en: 'Tickets',
        ro: 'Bilete',
        ru: 'Купоны',
        uk: 'Білети',
        pt: 'Bilhetes',
        gr: 'Δελτία',
        de: 'Tickets',
        no: 'Billetter',
        da: 'Billetter',
        es: 'Boletos',
        fr: 'Billets',
        ja: 'チケット',
        fi: 'Kupongit', //end
    },
    search: {
        en: 'Search',
        ro: 'Căutare',
        ru: 'ru',
        uk: 'uk',
        pt: 'Pesquisar',
        gr: 'Αναζήτηση',
        de: 'Suche',
        no: 'Søk',
        da: 'Søgning',
        es: 'Buscar',
        fr: 'Recherche',
        ja: 'サーチ',
        fi: 'Etsi', //end
    },
    rareNb: {
        en: 'The 5 rareest numbers',
        ro: 'Cele mai rare 5 numere',
        ru: '5 самых редких номеров',
        uk: 'uk',
        pt: 'Os 5 números mais raros',
        gr: 'Οι πιο σπάνιοι 5 αριθμοί',
        de: 'Die 5 seltesten Zahlen',
        no: 'De 5 sjeldneste tallene',
        da: 'De 5 sjældneste tal',
        es: 'Los 5 números poco frecuentes',
        fr: 'Les 5 numéros les plus rares',
        ja: '最も稀な5つの数字',
        fi: '5 harvinaisinta numeroa', //end
    },
    freqNb: {
        en: 'The most common 5 numbers',
        ro: 'Cele mai frecvente 5 numere ',
        ru: '5 самых частых номеров',
        uk: 'uk',
        pt: 'Os 5 números mais comuns',
        gr: 'Οι πιο συχνοί 5 αριθμοί',
        de: 'Die 5 häufigsten Zahlen',
        no: 'De 5 vanligste tallene',
        da: 'De mest almindelige 5 numre',
        es: 'Los 5 números más comunes',
        fr: 'Les 5 numéros les plus fréquents',
        ja: '最も一般的な5つの数字',
        fi: "5 yleisint' numeroa", //end
    },
    freqPairs: {
        en: '5 common pairs',
        ro: '5 perechi frecvente',
        ru: '5 частых пар',
        uk: 'uk',
        pt: '5 duplas comuns',
        gr: '5 συχνά ζεύγη',
        de: '5 übliche Paare',
        no: '5 hyppige par',
        da: '5 hyppige par',
        es: '5 parejas comunes',
        fr: '5 paires fréquentes',
        ja: '一般的な5つのペア',
        fi: "5 yleisint' paria", //end
    },
    freqConsPairs: {
        en: '5 consecutive frequent pairs',
        ro: '5 perechi frecvente consecutive',
        ru: '5 последовательных частых пар',
        uk: 'uk',
        pt: '5 duplas comuns e frequentes',
        gr: '5 συνεχόμενα συχνά ζεύγη',
        de: '5 aufeinander folgende häufige Paare',
        no: '5 sammenhengende hyppige par',
        da: '5 fortløbende hyppige par',
        es: '5 parejas frecuentes consecutivas',
        fr: '5 paires fréquentes consécutives',
        ja: '5つ連続で一般ペア',
        fi: '5 peräkkäsitä toistuvaa paria', //end
    },
    freq: {
        en: 'Frequency',
        ro: 'Frecvență',
        ru: 'ru',
        uk: 'uk',
        pt: 'Frequência',
        gr: 'Συχνότητα',
        de: 'Häufigkeit',
        no: 'Hyppighet',
        da: 'Hyppighed',
        es: 'Frecuencia',
        fr: 'Fréquence ',
        ja: '回数',
        fi: 'Toistuvuus', //end
    },
    statInfo: {
        en: 'The statistics are based on the results of the last 100 rounds',
        ro: 'Statisticile sunt realizate pe baza rezultatelor ultimelor 100 de runde',
        ru: 'ru',
        uk: 'uk',
        pt: 'As estatísticas são baseadas nos resultados das últimas 100 rondas',
        gr: 'Τα στατιστικά στοιχεία βασίζονται στα αποτελέσματα των τελευταίων 100 γύρων',
        de: 'Die Statistiken beruhen auf den Ergebnissen der letzten 100 Runden',
        no: 'Statistikken er basert på resultatene fra de siste 100 spillerundene',
        da: 'Statistikken er baseret på resultaterne fra de sidste 100 spilrundene',
        es: 'Las estadísticas se basan en los resultados de las últimas 100 rondas',
        fr: 'Les statistiques sont basées sur les résultats des 100 derniers tours',
        ja: '統計は過去100ラウンドの結果に基づいています',
        fi: 'Tilastot perustuvat 100 viimeisen kierroksen tuloksiin', //end
    },
    nrStat: {
        en: 'Numbers statistics',
        ro: 'Statistici pe numere',
        ru: 'Στατιστικά στοιχεία σε αριθμούς',
        uk: 'uk',
        pt: 'Números estatísticos',
        gr: 'Statistikk over tall',
        de: 'Zahlen Statistiken',
        no: 'Statistik over tal',
        da: 'Estadísticas sobre números',
        es: 'Estadísticas de números',
        fr: 'Statistiques sur les chiffres',
        ja: '数字の統計',
        fi: 'Numerotilastot', //end
    },
    nb: {
        en: 'Number',
        ro: 'Număr',
        ru: 'ru',
        uk: 'uk',
        pt: 'Número',
        gr: 'Αριθμός',
        de: 'Zahl',
        no: 'Nummer',
        da: 'Nummer',
        es: 'Número',
        fr: 'Numéro',
        ja: '番号',
        fi: 'Numero', //end
    },
    draw: {
        en: 'Draw',
        ro: 'Runda',
        ru: "Тираж",
        uk: "Тираж",
        pt: 'Extração',
        gr: 'Κλήρωση',
        de: 'Ziehung',
        no: 'Uttrekk',
        da: 'Udtræk',
        es: 'Extracción',
        fr: 'Extraction',
        ja: '引き分け',
        fi: 'Arvonta', //end
    },
    randomNb: {
        en: 'Random Numbers',
        ro: 'Nr. Aleatorii',
        ru: 'ru',
        uk: 'uk',
        pt: 'Números aleatórios',
        gr: 'Τυχαίοι αριθμοί',
        de: 'Zufällige Zahlen',
        no: 'Tilfeldige tall',
        da: 'Tilfældige tal',
        es: 'Números al azar',
        fr: 'Numéros aléatoires',
        ja: '乱数',
        fi: 'Satunnaiset numerot', //end
    },
    refresh: {
        en: 'Refresh',
        ro: 'Actualizare',
        ru: 'ru',
        uk: 'uk',
        pt: 'Atualizar',
        gr: 'Ανανέωση',
        de: 'Aktualisieren',
        no: 'Refresh',
        da: 'Refresh',
        es: 'Refrescar',
        fr: 'Rafraichir',
        ja: '更新する',
        fi: 'Päivitä', //end
    },
    clear: {
        en: 'Clear',
        ro: 'Șterge',
        ru: 'ru',
        uk: 'uk',
        pt: 'Apagar',
        gr: 'Σβήσε',
        de: 'Leeren',
        no: 'Klar',
        da: 'Klar',
        es: 'Borrar',
        fr: 'Efface',
        ja: 'クリア',
        fi: 'Tyhjennä', //end
    },
    possWin2: {
        en: 'Possible Winnnings',
        ro: 'Câștiguri posibile',
        ru: 'ru',
        uk: 'uk',
        pt: 'Ganhos possíveis',
        gr: 'Πιθανά κέρδη',
        de: 'Mögliche Gewinne',
        no: 'Mulige gevinster',
        da: 'Mulige gevinster',
        es: 'Posibles ganancias',
        fr: 'Gains possibles',
        ja: '可能な賞金',
        fi: 'Mahdollinen voitto', //end
    },
    possWinInfo: {
        en: 'Possible winnings based on the number of guessed balls',
        ro: 'Câștigurile posibile în funcție de numărul bilelor ghicite',
        ru: 'ru',
        uk: 'uk',
        pt: 'Ganhos possíveis baseados no número de bolas adivinhadas',
        gr: 'Πιθανά κέρδη με βάση το πόσες μπίλιες μάντεψες',
        de: 'Mögliche Gewinne beruhend auf der Anzahl der erratenen Bälle',
        no: 'Mulige gevinster basert på antall gjettet baller',
        da: 'Mulige gevinster baseret på antallet af gættede bolde',
        es: 'Posibles ganancias basadas en el número de bolas adivinadas',
        fr: 'Gains possibles basés sur le nombre de balles supposées',
        ja: '推測されたボールの数に基づいて可能な賞金',
        fi: 'Mahdolliset voitot arvattujen pallojen lukumäärän perusteella', //end
    },
    enterStake: {
        en: 'Enter stake',
        ro: 'Introduceți miza',
        ru: 'ru',
        uk: 'uk',
        pt: 'Introduzir a aposta',
        gr: 'Εισάγετε ποντάρισμα',
        de: 'Einsatz eingeben',
        no: 'Skriv inn innsats',
        da: 'Indtast indsats',
        es: 'Poner estaca',
        fr: 'Entrez en jeu',
        ja: 'ステークを入力',
        fi: 'Aseta panos', //end
    },
    possWin: {
        en: 'Possible Winnning',
        ro: 'Câștig posibil',
        ru: 'ru',
        uk: 'uk',
        pt: 'Ganho possível',
        gr: 'Πιθανό κέρδος',
        de: 'Mögliches Gewinn',
        no: 'Mulig gevinst',
        da: 'Mulig gevinst',
        es: 'Posible ganancia',
        fr: 'Gain possible',
        ja: '可能な賞金',
        fi: 'Mahdollinen voitto', //end
    },
    hitsNb: {
        en: 'Hits',
        ro: 'Nr. Hituri',
        ru: 'ru',
        uk: 'uk',
        pt: 'Tiros',
        gr: 'Αριθ. χτυπήματα',
        de: 'Treffer',
        no: 'Antal hits',
        da: 'Antal hits',
        es: 'Golpes',
        fr: 'No. visites',
        ja: 'ヒット',
        fi: 'Osuma', //end
    },
    odds: {
        en: 'Odds',
        ro: 'Cote',
        ru: 'ru',
        uk: 'uk',
        pt: 'Probabilidades',
        gr: 'Μερίδια',
        de: 'Chancen',
        no: 'Odds',
        da: 'Odds',
        es: 'Posibilidades',
        fr: 'Cotes',
        ja: 'オッズ',
        fi: 'Kertoimet', //end
    },
    repeatBet: {
        en: 'Repeat Bet',
        ro: 'Repetare pariu',
        ru: 'ru',
        uk: 'uk',
        pt: 'Repetir aposta',
        gr: 'Επανάληψη στοίχημα',
        de: 'Wette wiederholen',
        no: 'Gjenta veddemål',
        da: 'Gentag væddemål',
        es: 'Apuesta repetida',
        fr: 'Répéter le pari',
        ja: 'ベットをやり直す',
        fi: 'Toista veto', //end
    },
    repeatBetInfo: {
        en: 'Repeat selection for subsequent consecutive rounds',
        ro: 'Repetare selecție pentru urmatoarele runde consecutive',
        ru: 'ru',
        uk: 'uk',
        pt: 'Repetir seleção para as seguintes rondas consecutivas',
        gr: 'Επανάληψη επιλογής για επόμενους διαδοχικούς γύρους',
        de: 'Wiederholen der Auswahl für anschließende aufeinanderfolgende Runden',
        no: 'Gjenta valg for påfølgende sammenhengende spillerunder',
        da: 'Gentag valg for efterfølgende fortløbende spilrunder',
        es: 'Repetir selección para las siguientes rondas consecutivas',
        fr: 'Répéter la sélection pour les tours consécutifs suivants',
        ja: '後続の連続ラウンドに基づいて選択をやり直す',
        fi: 'Toista valinta seuraaville peräkkäisille kierroksille', //end
    },
    addFavNb: {
        en: 'Add to favorite numbers',
        ro: 'Adaugă la numere favorite',
        ru: 'ru',
        uk: 'uk',
        pt: 'Adicionar aos números favoritos',
        gr: 'Πρόσθεσε στους αγαπημένους αριθμούς',
        de: 'Zu den Lieblingszahlen hinzufügen',
        no: 'Legg til i favorittnumre',
        da: 'Tilføj til foretrukne numre',
        es: 'Añadir a números favoritos',
        fr: 'Ajouter aux numeros favoris',
        ja: 'お気に入りの番号に追加',
        fi: 'Lisää suosikkinumeroihin', //end
    },
    fav: {
        en: 'Favorite',
        ro: 'Favorite',
        ru: 'ru',
        uk: 'uk',
        pt: 'Favoritos',
        gr: 'Αγαπημένα',
        de: 'Favoriten',
        no: 'Favoritter',
        da: 'Favoriter',
        es: 'Favorito',
        fr: 'Favoris',
        ja: 'お気に入り',
        fi: 'Suosikki', //end
    },
    selectFavNb: {
        en: 'Select favorite numbers',
        ro: 'Selectează numere favorite',
        ru: 'ru',
        uk: 'uk',
        pt: 'Selecionar os números favoritos',
        gr: 'Διάλεξε τους αγαπημένους αριθμούς',
        de: 'Lieblingszahlen auswählen',
        no: 'Velg favorittnumre',
        da: 'Vælg favoritnumre',
        es: 'Seleccionar números favoritos',
        fr: 'Sélectionne les numéros favoris',
        ja: 'お気に入り番号を選択',
        fi: 'Valitse suosikkinumerot', //end
    },
    nofavNb: {
        en: 'There are no favorite numbers',
        ro: 'Nu există numere favorite',
        ru: 'ru',
        uk: 'uk',
        pt: 'Não há números favoritos',
        gr: 'Δεν υπάρχουν αγαπημένοι αριθμοί',
        de: 'Es gibt keine Lieblingszahlen',
        no: 'Det er ingen favorittnumre',
        da: 'Der er ingen favoritnumre',
        es: 'No hay números favoritos',
        fr: "Il n'y a pas de numéros favoris",
        ja: 'お気に入り番号はありません',
        fi: 'Ei suosikkinumeroita', //end
    },
    mizaInfo: {
        en: 'The minimum value is',
        ro: 'Valoarea minimă este de',
        ru: 'ru',
        uk: 'uk',
        pt: 'O valor mínimo é',
        gr: 'Η ελάχιστη αξία είναι',
        de: 'Der Mindeswert ist',
        no: 'Minimumsverdien er',
        da: 'Minimumsværdien er',
        es: 'El valor mínimo es',
        fr: 'La valeur minimale est',
        ja: '最小値',
        fi: 'Vähimmäisarvo on', //end
    },
    odd: {
        en: 'Odd',
        ro: 'Cotă',
        ru: 'ru',
        uk: 'uk',
        pt: 'Probabilidade',
        gr: 'Μερίδιο',
        de: 'Chance',
        no: 'Odds',
        da: 'Odds',
        es: 'Posibilidad',
        fr: 'Cotes',
        ja: 'オッズ',
        fi: 'Kerroin', //end
    },
    oddInfo: {
        en: 'Cumulative odds that are obtained if all the numbers played are guessed',
        ro: 'Cota cumulată care se obține dacă se ghicesc toate numerele jucate',
        ru: 'ru',
        uk: 'uk',
        pt: 'A probabilidade acumulada que se obtém se todos os números serem adivinhados',
        gr: 'Οι αθροιστικές αποδόσεις που αποκτώνται όταν μαντεύεις όλους τους αριθμούς που παίζονται',
        de: 'Kumulative Chancen, die erhalten werden, wenn alle gespielten Zahlen erraten werden',
        no: 'Kumulative odds som er oppnådd dersom alle tallene som spilles gjettes',
        da: 'Kumulative odds, der opnås, hvis alle de talte tal er gættet',
        es: 'Probabilidades acumulativas que se obtienen si todos los números jugados se adivinan',
        fr: 'Cotes cumulatives obtenues si tous les nombres joués sont tous devinés',
        ja: 'すべての番号が推測されるならば、得られる累積的な確率',
        fi: 'Kumulatiiviset kertoimet, jotka saadaan, jos kaikki soitetut numerot arvataan', //end
    },
    totalBets: {
        en: 'Total bets',
        ro: 'Total pariuri',
        ru: 'ru',
        uk: 'uk',
        pt: 'Total dos apostas',
        gr: 'Σύνολο στοιχήματα',
        de: 'Gesamtwetten',
        no: 'Samlet veddemål',
        da: 'Samlede væddemål',
        es: 'Apuestas totales',
        fr: 'Total des paris',
        ja: '会計ベット',
        fi: 'Vedot yhteensä', //end
    },
    totalStake: {
        en: 'Total stake',
        ro: 'Total miză',
        ru: 'ru',
        uk: 'uk',
        pt: 'Total das probabilidades',
        gr: 'Σύνολο ποντάρισμα',
        de: 'Gesamteinsatz',
        no: 'Samlet odds',
        da: 'Samlede odds',
        es: 'Estaca total',
        fr: 'Total de la mise ',
        ja: '会計ステーク',
        fi: 'Panokset yhteensä', //end
    },
    win2: {
        en: 'Winnings',
        ro: 'Câștiguri',
        ru: 'ru',
        uk: 'uk',
        pt: 'Ganhos',
        gr: 'Κέρδη',
        de: 'Gewinne',
        no: 'Gevinster',
        da: 'Gevinster',
        es: 'Ganancias',
        fr: 'Gains',
        ja: '勝ち',
        fi: 'Voitot', //end
    },
    emptyTicket: {
        en: 'Select your favorite numbers from the left side',
        ro: 'Selectați numerele preferate din stânga paginii',
        ru: 'ru',
        uk: 'uk',
        pt: 'Selecionar os seus números favoritos do lado esquerdo da página',
        gr: 'Επιλέξτε τους αριθμούς που προτιμάτε στα αριστερά της σελίδας',
        de: 'Wählen Sie Ihre Lieblingszahl von der linken Seite',
        no: 'Velg favorittnumrene til venstre for siden',
        da: 'Vælg favoritnumrene til venstre for siden',
        es: 'Seleccione sus números favoritos del lado izquierdo',
        fr: 'Sélectionnez vos numéros préférés à gauche de la page',
        ja: 'お気に入り番号を左から選択',
        fi: 'Valitse suosikkinumerosi vasemmalta puolelta', //end
    },
    deleteSelec: {
        en: 'Delete all selections',
        ro: 'Elimină selecțiile',
        ru: 'ru',
        uk: 'uk',
        pt: 'Apagar todas as seleções',
        gr: 'Κατάργησε τις επιλογές',
        de: 'Alle Auswahlen löschen',
        no: 'Eliminerer valg',
        da: 'Eliminerer markeringer',
        es: 'Borrar todas las selecciones',
        fr: 'Élimine les sélections',
        ja: 'すべての選択を削除',
        fi: 'Poista valinnat', //end
    },
    lotWinners: {
        en: 'Lottery winners',
        ro: 'Câștigători Loterii',
        ru: 'ru',
        uk: 'uk',
        pt: 'Ganhadores da Loteria',
        gr: 'Νικητές λοταρίας',
        de: 'Lotteriegewinner',
        no: 'Lotteri vinnere',
        da: 'Lotteri vindere',
        es: 'Ganadores de loteria',
        fr: 'Gagnants des Loteries',
        ja: '宝くじ当選者',
        fi: 'Lotto voittajat', //end
    },
    expTicket: {
        en: 'Expired ticket',
        ro: 'Bilet expirat',
        ru: 'ru',
        uk: 'uk',
        pt: 'Bilhete vencido',
        gr: 'Ληγμένο δελτίο',
        de: 'Abgelaufenes Ticket',
        no: 'Utløpt billett',
        da: 'Udløbet billet',
        es: 'Boleto vencido',
        fr: 'Billet expiré',
        ja: '期限切れのチケット',
        fi: 'Vanhentunut kuponki', //end
    },
    weekly: {
        en: 'Weekly',
        ro: 'Săptămânal',
        ru: 'ru',
        uk: 'uk',
        pt: 'Semanal',
        gr: 'Εβδομαδιαία',
        de: 'Wochentlich',
        no: 'Ukentlig',
        da: 'Ugentlig',
        es: 'Semanal',
        fr: 'Hebdomadaire',
        ja: '毎週',
        fi: 'Viikottainen', //end
    },
    monthly: {
        en: 'Monthly',
        ro: 'Lunar',
        ru: 'ru',
        uk: 'uk',
        pt: 'Mensal',
        gr: 'Μηνιαία',
        de: 'Monatlich',
        no: 'Månedlig',
        da: 'Månedlige',
        es: 'Mensual',
        fr: 'Mensuel',
        ja: '毎月',
        fi: 'Kuukausittainen', //end
    },
    annual: {
        en: 'Annual',
        ro: 'Anual',
        ru: 'ru',
        uk: 'uk',
        pt: 'Anual',
        gr: 'Ετήσια',
        de: 'Jährlich',
        no: 'Årlig',
        da: 'Årligt',
        es: 'Anual',
        fr: 'Annuel',
        ja: '毎年',
        fi: 'Vuosittainen', //end
    },
    lastWeek: {
        en: 'Last week',
        ro: 'Săptămâna trecută',
        ru: 'ru',
        uk: 'uk',
        pt: 'Semana passada',
        gr: 'Η προηγούμενη εβδομάδα',
        de: 'Vorrige Woche',
        no: 'Forrige uke',
        da: 'Sidste uge',
        es: 'La semana pasada',
        fr: 'La semaine dernière',
        ja: '先週',
        fi: 'Edellinen viikko', //end
    },
    thisWeek: {
        en: 'This week',
        ro: 'Săptămâna aceasta',
        ru: 'ru',
        uk: 'uk',
        pt: 'Esta semana',
        gr: 'Αυτή η εβδομάδα',
        de: 'Diese Woche',
        no: 'Denne uke',
        da: 'Denne uge',
        es: 'Esta semana',
        fr: 'Cette semaine',
        ja: '今週',
        fi: 'Tämä viikko', //end
    },
    lastMonth: {
        en: 'Last month',
        ro: 'Luna trecută',
        ru: 'ru',
        uk: 'uk',
        pt: 'Mês passado',
        gr: 'Ο προηγούμενος μήνας',
        de: 'Vorriges Monat',
        no: 'Siste måned',
        da: 'Sidste måned',
        es: 'El mes pasado',
        fr: 'Le mois dernier',
        ja: '先月',
        fi: 'Viime kuukausi', //end
    },
    thisMonth: {
        en: 'This month',
        ro: 'Luna aceasta',
        ru: 'ru',
        uk: 'uk',
        pt: 'Este mês',
        gr: 'Αυτός ο μήνας',
        de: 'Dieses Monat',
        no: 'Denne måned',
        da: 'Denne måned',
        es: 'Este mes',
        fr: 'Ce mois-ci',
        ja: '今月',
        fi: 'Tämä kuukausi', //end
    },
    lastYear: {
        en: 'Last year',
        ro: 'Anul trecut',
        ru: 'ru',
        uk: 'uk',
        pt: 'Ano passado',
        gr: 'Πέρυσι',
        de: 'Vorriges Jahr',
        no: 'I fjor',
        da: 'Sidste år',
        es: 'El año pasado',
        fr: "L'année dernière",
        ja: '昨年',
        fi: 'Viime vuosi', //end
    },
    thisYear: {
        en: 'This year',
        ro: 'Anul acesta',
        ru: 'ru',
        uk: 'uk',
        pt: 'Este ano',
        gr: 'Φέτος',
        de: 'Dieses Jahr',
        no: 'I år',
        da: 'I år',
        es: 'Este año',
        fr: 'Cette année',
        ja: '今年',
        fi: 'Tämä vuosi', //end
    },
    stake: {
        en: 'Stake',
        ro: 'Miză',
        ru: 'Ставка',
        uk: 'Ставка',
        pt: 'Probabilidade',
        gr: 'Στοίχημα',
        de: 'Einsatz',
        no: 'Stake',
        da: 'Aktiepost',
        es: 'Estaca',
        fr: 'Mise',
        ja: 'ステーク',
        fi: 'Panos', //end
    },
    ticketId: {
        en: 'Ticket ID',
        ro: 'ID bilet',
        ru: 'ru',
        uk: 'uk',
        pt: 'ID do bilhete',
        gr: 'ID δελτίο',
        de: 'Ticketnummer',
        no: 'Billett-ID',
        da: 'Billett-ID',
        es: 'ID de entrada',
        fr: 'ID billet',
        ja: 'チケットID',
        fi: 'Kuponkitunnus', //end
    },
    nextRound: {
        en: 'NEXT ROUND',
        ro: 'URMĂTOAREA RUNDĂ',
        ru: 'ru',
        uk: 'uk',
        pt: 'PRÓXIMA RONDA',
        gr: 'ΕΠΟΜΕΝΟΣ ΓΥΡΟΣ',
        de: 'NÄCHSTE RUNDE',
        no: 'NESTE SPILLERUNDE',
        da: 'NÆSTE SPILRUNDE',
        es: 'RONDA SIGUIENTE',
        fr: 'LA ROUNDE SUIVANTE',
        ja: '次のラウンド/次のラウンド',
        fi: 'SEURAAVA KIERRO', //end
    },
    start: {
        en: 'START',
        ro: 'START',
        ru: 'ru',
        uk: 'uk',
        pt: 'INÍCIO',
        gr: 'ΑΡΧΙΖΕΙ',
        de: 'START',
        no: 'START',
        da: 'START',
        es: 'COMIENZO',
        fr: 'COMMENCE',
        ja: '開始',
        fi: 'ALKU', //end
    },
    startsSoon: {
        en: 'STARTS SOON',
        ro: 'ÎNCEPE CURÂND',
        ru: 'ru',
        uk: 'uk',
        pt: 'COMEÇA EM BREVE',
        gr: 'ΑΡΧΙΖΕΙ ΣΥΝΤΟΜΑ',
        de: 'BEGINNT BALD',
        no: 'START SNART',
        da: 'START SNART',
        es: 'COMIENZA PRONTO',
        fr: 'COMMENCE BIENTÔT',
        ja: 'すぐにスタート',
        fi: 'ALKAA KOHTA', //end
    },
    date: {
        en: 'DATE',
        ro: 'DATĂ',
        ru: 'ru',
        uk: 'uk',
        pt: 'DATA',
        gr: 'ΗΜΕΡΟΜΗΝΙΑ',
        de: 'DATUM',
        no: 'DATO',
        da: 'DATO',
        es: 'FECHA',
        fr: 'DATE',
        ja: '日付',
        fi: 'PVM', //end
    },
    hour: {
        en: 'HOUR',
        ro: 'ORĂ',
        ru: 'ru',
        uk: 'uk',
        pt: 'HORA',
        gr: 'ΩΡΑ',
        de: 'UHRZEIT',
        no: 'TID',
        da: 'TID',
        es: 'HORA',
        fr: 'HEURE',
        ja: '時',
        fi: 'TUNTI', //end
    },
    drawHour: {
        en: 'DRAW HOUR',
        ro: 'EXTRAGERE ORĂ',
        ru: 'ru',
        uk: 'uk',
        pt: 'HORA DA RIFA',
        gr: 'ΚΛΗΡΩΣΗ ΩΡΑ',
        de: 'UHRZEIT DER AUSSPIELUNG',
        no: 'UTDRAGSTID',
        da: 'TID TIL UDTRÆKNING',
        es: 'HORA DE SORTEO',
        fr: 'EXTRACTION HEURE',
        ja: '引き分け時',
        fi: 'ARVONTA-AIKA', //end
    },
    mostDrawnNb: {
        en: 'MOST DRAWN NUMBERS',
        ro: 'CELE MAI EXTRASE NUMERE',
        ru: 'ru',
        uk: 'uk',
        pt: 'OS NÚMEROS MAIS SORTEADOS',
        gr: 'ΤΑ ΠΙΟ ΣΥΧΝΑ ΚΛΗΡΩΜΕΝΑ ΝΟΥΜΕΡΑ',
        de: 'DIE MEIST GEZOGENEN ZAHLEN',
        no: 'DE MEST TRUKKET TALL',
        da: 'DE MEST UDTRUKNE NUMRE',
        es: 'La mayoría de los número extraídos',
        fr: 'LES NUMEROS LES PLUS EXTRAITS',
        ja: '最も引き分けた番号',
        fi: 'ENITEN ARVOTUT NUMEROT', //end
    },
    upcoming: {
        en: "Upcoming",
        ro: "Urmează",
        ru: "Тираж",
        uk: "Майбутні",
        pt: "Próximas",
        gr: "Ανερχόμενος",
        de: "Bevorstehende",
        no: "Kommende",
        da: "Kommende",
        es: "Próxima",
        fr: "Prochain",
        ja: '今後の予定',
        fi: 'Tulevat', //end
    },
    nextDraws: {
        en: 'Next draws',
        ro: 'Următoarele extrageri',
        ru: 'Next draws',
        uk: 'Next draws',
        pt: 'Próximas rifas',
        gr: 'Next draws',
        de: 'Nächste ausspielungen',
        no: 'Next draws',
        da: 'Next draws',
        es: 'Próximos sorteos',
        fr: 'Extractions suivants',
        ja: '次の引き分け',
        fi: 'Seuraavat arvonnat', //end
    },
    cotaTopWinners: {
        en: 'Odds',
        ro: 'Cotă',
        ru: 'x',
        uk: 'x',
        pt: 'x',
        es: 'x',
        gr: 'x',
        de: 'Chancen',
        no: 'x',
        da: 'x',
        fr: 'x',
        ja: 'オッズ',
        fi: 'Kertoimet', //end
    },
    winChances: {
        en: 'Chances to win',
        ro: 'Șanse de câștig',
        ru: 'Шансы на выигрыш',
        uk: 'Шанс виграти',
        pt: 'Possibilidades de ganhar',
        gr: 'Chances to win',
        de: 'Chancen zum Gewinn',
        no: 'Chances to win',
        da: 'Chances to win',
        es: 'Posibilidades de ganar',
        fr: 'Chances de gagner',
        ja: '勝つチャンス',
        fi: 'Voittomahdollisuudet', //end
    },
    less: {
        en: 'less',
        ro: 'mai puțin',
        ru: 'меньше',
        uk: 'Менше',
        pt: 'menos',
        gr: 'less',
        de: 'weniger',
        no: 'less',
        da: 'less',
        es: 'menos',
        fr: 'moins',
        ja: 'もっと少なく',
        fi: 'vähemmän', //end
    },
    more: {
        en: 'more',
        ro: 'mai mult',
        ru: 'больше',
        uk: 'Більше',
        hr: 'Više',
        pt: 'mais',
        gr: 'more',
        de: 'mehr',
        no: 'more',
        da: 'more',
        es: 'más',
        fr: 'plus',
        ja: 'もっと',
        fi: 'isää', //end
    },
    moneyAmount: {
        en: 'Amount of money',
        ro: 'Sumă de bani',
        ru: 'Сумма выигрыша',
        uk: 'Сума коштів',
        pt: 'Quantia de dinheiro',
        gr: 'Amount of money',
        de: 'Geldbetrag',
        no: 'Amount of money',
        da: 'Amount of money',
        es: 'Cantidad de dinero',
        fr: "Somme d'argent",
        ja: '金額',
        fi: 'Rahamäärä', //end
    },
    biletePariate: {
        en: 'tickets placed',
        ro: 'bilete pariate cu succes',
        tk: 'petekler kabul edildi',
        ru: 'cтавки приняты успешно',
        es: 'boletos colocado',
        fr: 'billets placés',
        pt: 'bilhetes submetido',
        de: 'tickets platziert',
        ja: 'チケット発行',
        fi: 'Kupongit asetettu', //end
    },
    bileteEsuate: {
        en: 'tickets were not placed',
        ro: 'bilete neplasate',
        tk: 'petekler kabul edilmedi',
        ru: 'cледующее ставки не были приняты',
        es: 'boletos no colocados',
        fr: "billets n'ont pas été placés",
        pt: 'bilhetes não foi submetido',
        de: 'tickets wurde nicht platziert',
        ja: '金額',
        fi: 'Kuponkia ei hyväksytty', //end
    },
    conError: {
        en: 'Connection Error. Please, again try later.',
        ro: 'Eroare de conexiune. Vă rugăm să încercați mai târziu.',
        ru: 'Ошибка сети. Пожалуйста, попробуйте позднее.',
        uk: "Помилка з'єднання.Будь ласка, спробуйте пізніше",
        pt: 'Erro de conexão. O favor de tentar mais tarde.',
        gr: 'Σφάλμα σύνδεσης. Παρακαλώ δοκιμάστε και πάλι αργότερα.',
        de: 'Verbindungsfehler. Versuchen Sie bitte später.',
        tk: 'Internet näsazlygy, täzeden synanşyp görüň!',
        no: 'Tilkoblingsfeil. Prøv igjen senere.',
        da: 'Forbindelsesfejl. Prøv igen senere.',
        es: 'Error de Conexió. Por favor, intente más tarden.',
        fr: "Erreur de connexion. Veuillez réessayer plus tard.",
        ja: '接続エラー. 後でもう一度やり直してください',
        fi: 'Yhteysvirhe. Yritä uudelleen myöhemmin.',
    },
    oficialLinks: {
        ro: "Surse oficiale",
        en: "Official links",
        fi: "Viralliset linkit",
        tk: "Official links",
        ru: "Официальные источники",
        uk: "Офіційні посилання",
        es: "Enlaces oficiales",
        pt: "Links oficiais",
        de: "Offizielle Links",
        fr: "Liens officiels",
        ja: "公式リンク",
    },
    cursaLoteriilor: {
        en: "Lottery race",
        ro: "Cursa loteriilor",
        ru: "Lottery race",
        uk: "Lottery race",
        pt: "Lottery race",
        gr: "Lottery race",
        de: "Lottery race",
        no: "Lottery race",
        da: "Lottery race",
        es: "Lottery race",
        fr: "Lottery race"
    },
    premiiCash: {
        en: "Cash prizes",
        ro: "Premii cash",
        ru: "Cash prizes",
        uk: "Cash prizes",
        pt: "Cash prizes",
        gr: "Cash prizes",
        de: "Cash prizes",
        no: "Cash prizes",
        da: "Cash prizes",
        es: "Cash prizes",
        fr: "Cash prizes"
    },
    loc: {
        en: "Place",
        ro: "Loc",
        ru: "Place",
        uk: "Place",
        pt: "Place",
        gr: "Place",
        de: "Place",
        no: "Place",
        da: "Place",
        es: "Place",
        fr: "Place"
    },
    user: {
        en: "User",
        ro: "Utilizator",
        ru: "User",
        uk: "User",
        pt: "User",
        gr: "User",
        de: "User",
        no: "User",
        da: "User",
        es: "User",
        fr: "User"
    },
    points: {
        en: "Points",
        ro: "Puncte",
        ru: "Points",
        uk: "Points",
        pt: "Points",
        gr: "Points",
        de: "Points",
        no: "Points",
        da: "Points",
        es: "Points",
        fr: "Points"
    },
    prize: {
        en: "Prize",
        ro: "Premiu",
        ru: "Prize",
        uk: "Prize",
        pt: "Prize",
        gr: "Prize",
        de: "Prize",
        no: "Prize",
        da: "Prize",
        es: "Prize",
        fr: "Prize"
    },
    veziClasament: {
        en: "See the ranking",
        ro: "Vezi clasamentul",
        ru: "See the ranking",
        uk: "See the ranking",
        pt: "See the ranking",
        gr: "See the ranking",
        de: "See the ranking",
        no: "See the ranking",
        da: "See the ranking",
        es: "See the ranking",
        fr: "See the ranking"
    },
    position: {
        en: "Your position",
        ro: "Pozitia ta",
        ru: "Your position",
        uk: "Your position",
        pt: "Your position",
        gr: "Your position",
        de: "Your position",
        no: "Your position",
        da: "Your position",
        es: "Your position",
        fr: "Your position"
    },
    leaderboardRules1: {
        en: "The promotion take place between:",
        ro: "Cursa Loteriilor revine cu 150 de premii CASH în valoare totală de ",
        ru: "The promotion take place between:",
        uk: "The promotion take place between:",
        pt: "The promotion take place between:",
        gr: "The promotion take place between:",
        de: "The promotion take place between:",
        no: "The promotion take place between:",
        da: "The promotion take place between:",
        es: "The promotion take place between:",
        fr: "The promotion take place between:"
    },
    leaderboardRules2: {
        en: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2.",
        ro: "Promoția se desfășoară în intervalul 14 decembrie 2020, ora 16:00 - 03 ianuarie 2021, ora 23:59.",
        ru: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2.",
        uk: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2.",
        pt: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2.",
        gr: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2.",
        de: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2.",
        no: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2.",
        da: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2.",
        es: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2.",
        fr: "For every ticket the points awarded are: 0.8 plus bet amount(converted in euro currency) multiplied with 0.2."
    },
    leaderboardRules3: {
        en: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points.",
        ro: "Intră în competiție, joacă la loteriile tale preferate, iar noi îți răsplătim activitatea cu premii CASH!",
        ru: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points.",
        uk: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points.",
        pt: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points.",
        gr: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points.",
        de: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points.",
        no: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points.",
        da: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points.",
        es: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points.",
        fr: "For example, a ticket that has a bet amount equal with 10 euros you will obtain 0.8 + (0.2 X 10) = 2.8 points."
    },
    leaderboardRules4: {
        en: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account.",
        ro: "Orice loterie din selecția NetBet Loto îți poate asigura un loc câștigător.",
        ru: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account.",
        uk: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account.",
        pt: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account.",
        gr: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account.",
        de: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account.",
        no: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account.",
        da: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account.",
        es: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account.",
        fr: "For obtaining the final score for each partaker in Loto Mania, the first 150 tickets from each day of the promotion will be taken into account."
    },
    leaderboardRules5: {
        en: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        ro: "Pentru fiecare utilizator, la calcularea punctajului se vor lua în considerare doar primele 150 de bilete plasate în decursul unei zile.",
        ru: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        uk: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        pt: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        gr: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        de: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        no: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        da: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        es: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        fr: "In every week the first 150 players will be honoured with prize money of 6,000 RON."
    },
    leaderboardRules6: {
        en: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        ro: "Poziția din clasament se va calcula pe baza numărului de puncte acumulate în cadrul perioadei promoționale: (1 punct/ bilet plasat ) + (suma pariată x 0,20).",
        ru: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        uk: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        pt: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        gr: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        de: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        no: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        da: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        es: "In every week the first 150 players will be honoured with prize money of 6,000 RON.",
        fr: "In every week the first 150 players will be honoured with prize money of 6,000 RON."
    },
    detaliiPromo: {
        en: "See here all details of Loto Mania tournament.",
        ro: "Vezi aici detaliile complete ale promotiei.",
        ru: "See here all details of Loto Mania tournament.",
        uk: "See here all details of Loto Mania tournament.",
        pt: "See here all details of Loto Mania tournament.",
        gr: "See here all details of Loto Mania tournament.",
        de: "See here all details of Loto Mania tournament.",
        no: "See here all details of Loto Mania tournament.",
        da: "See here all details of Loto Mania tournament.",
        es: "See here all details of Loto Mania tournament.",
        fr: "See here all details of Loto Mania tournament."
    },
    week: {
        en: "Week",
        ro: "Saptamana",
        ru: "Week",
        uk: "Week",
        pt: "Week",
        gr: "Week",
        de: "Week",
        no: "Week",
        da: "Week",
        es: "Week",
        fr: "Week"
    },
    clasamentSaptAnterioara: {
        en: "Last week ranking",
        ro: "Clasament Saptamana Anterioara",
        ru: "Last week ranking",
        uk: "Last week ranking",
        pt: "Last week ranking",
        gr: "Last week ranking",
        de: "Last week ranking",
        no: "Last week ranking",
        da: "Last week ranking",
        es: "Last week ranking",
        fr: "Last week ranking"
    },
    headerStTop: {
        en: 'Top Lotteries',
        ro: 'Loterii de top',
        ru: 'Лотерея',
        uk: 'Лотерея',
        pt: 'Lotarias',
        gr: 'Λοταρίες',
        de: 'Lotterien',
        no: 'Lotterier',
        da: 'Lotterier',
        es: 'Loterías',
        fr: 'Loteries',
    },
    coteMarite: {
        en: 'New odds',
        ro: 'cote noi',
        ru: 'New odds',
        uk: 'New odds',
        pt: 'New odds',
        gr: 'New odds',
        de: 'New odds',
        no: 'New odds',
        da: 'New odds',
        es: 'New odds',
        fr: 'New odds',
    },
}

export default function (state = null, action) {
    if (action.type === 'MULTI_LANGUAGE') {
        var lang = action.payload.language.toLowerCase();
        // lang = 'fr'
        var selectLanguage = {};
        Object.keys(languages).forEach(function (key1) {
            //   console.log(key1);
            if (languages[key1][lang]) {
                selectLanguage[key1] = { txt: languages[key1][lang] }
            }
            return languages;
        });
        state = selectLanguage;
    }
    return state;
}

// {this.props.multiLang.xxxxx.txt}